import React, { useState } from 'react';
import Main from 'components/main';
import MainMenu from 'components/mainMenu';
import ModulesData from 'components/modulesData';
import CheckListData from 'components/checkListData';
import General from 'components/general';
import Final from 'components/final';

const Steps = () => {
  const [step, setStep] = useState(0);
  const [menu, setMenu] = useState(0);

  return (
    <>
      {step === 0 && <Main step={step} setStep={setStep} />}
      {step === 1 && <MainMenu step={step} setStep={setStep} setMenu={setMenu} complete={0} /> }
      {step === 2 && <ModulesData menu={menu} step={step} setStep={setStep} />  }
      {step === 3 && <ModulesData menu={menu} step={step} setStep={setStep} />  }
      {step === 4 && <MainMenu step={step} setStep={setStep} setMenu={setMenu} complete={1} /> }
      {step === 5 && <General step={step} setStep={setStep} /> }
      {step === 6 && <Final/> }
    </>
  );
};

export default Steps;
